// Stub temporal para iconos SVG
// Exportamos componentes vacíos que aceptan props

import React from 'react';

type IconProps = React.SVGProps<SVGSVGElement>;

const createStubIcon = (): React.FC<IconProps> => (props) => null;

export const PlusIcon = createStubIcon();
export const CloseIcon = createStubIcon();
export const BoxIcon = createStubIcon();
export const CheckCircleIcon = createStubIcon();
export const AlertIcon = createStubIcon();
export const InfoIcon = createStubIcon();
export const ErrorIcon = createStubIcon();
export const BoltIcon = createStubIcon();
export const ArrowUpIcon = createStubIcon();
export const ArrowDownIcon = createStubIcon();
export const FolderIcon = createStubIcon();
export const VideoIcon = createStubIcon();
export const AudioIcon = createStubIcon();
export const GridIcon = createStubIcon();
export const FileIcon = createStubIcon();
export const DownloadIcon = createStubIcon();
export const ArrowRightIcon = createStubIcon();
export const GroupIcon = createStubIcon();
export const BoxIconLine = createStubIcon();
export const ShootingStarIcon = createStubIcon();
export const DollarLineIcon = createStubIcon();
export const TrashIcon = createStubIcon();
export const TicketDollarIcon = createStubIcon();
export const ClockIcon = createStubIcon();
export const DiamondIcon = createStubIcon();
export const BellIcon = createStubIcon();
export const BellCrossIcon = createStubIcon();
export const CheckIcon = createStubIcon();
export const ExclamationIcon = createStubIcon();
export const HomeIcon = createStubIcon();
export const CalenderIcon = createStubIcon();
export const EyeIcon = createStubIcon();
export const EyeCloseIcon = createStubIcon();
export const TimeIcon = createStubIcon();
export const CopyIcon = createStubIcon();
export const ChevronLeftIcon = createStubIcon();
export const ChevronDownIcon = createStubIcon();
export const LockIcon = createStubIcon();
export const UserCircleIcon = createStubIcon();
export const TaskIcon = createStubIcon();
export const ListIcon = createStubIcon();
export const TableIcon = createStubIcon();
export const PageIcon = createStubIcon();
export const PieChartIcon = createStubIcon();
export const BoxCubeIcon = createStubIcon();
export const PlugInIcon = createStubIcon();
export const DocsIcon = createStubIcon();
export const MailIcon = createStubIcon();
export const EnvelopeIcon = createStubIcon();
export const HorizontaLDots = createStubIcon();
export const ChatIcon = createStubIcon();
export const MoreDotIcon = createStubIcon();
export const AlertHexaIcon = createStubIcon();
export const ErrorHexaIcon = createStubIcon();
